const displayPercentage = (rate: number) => ( rate ? `${Math.round(rate * 1000) / 10}%` : '0%' )

export default displayPercentage